import React, { useEffect } from "react";
import "../Home/Home.css";
import { motion as m } from "framer-motion";
import { IoIosArrowForward } from "react-icons/io";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-32">
          <div className="card_titleBanner relative w-full pt-14 pb-12 group rounded-lg overflow-hidden flex flex-col bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold transition-all duration-300 ease-in-out">
            <div className="flex flex-col sm:items-center">
              <h1 className="font-semibold uppercase text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
                Privacy Policy
                <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </h1>

              <p className="flex items-center gap-1 mt-3 text-sm">
                Home <IoIosArrowForward className="text-teal-600" />
                <i>Privacy Policy</i>
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pb-10">
          <div className="my-5 lg:my-8">
            <p className="font-semibold">
              Welcome to Init Technology. Your privacy is critically important
              to us. This Privacy Policy outlines how we collect, use, and
              protect your information when you use our website, services, and
              products.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <h2 className="font-semibold my-2 md:my-4">
              1. Information We Collect
            </h2>
            <p>
              • Personal Information: We may collect personal information such
              as your name, email address, and phone number, when you register,
              or interact with our services.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <h3 className="font-semibold my-2 md:my-4">
              2. How We Use Your Information
            </h3>
            <p>
              • Communication: We may use your contact information to send you
              updates, newsletters, promotional materials, and other information
              related to our services.
            </p>

            <p className="mt-2 lg:mt-4">
              • Analytics: Non-personal information may be used for analytical
              purposes to understand user behaviour and improve our website and
              services.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <h4 className="font-semibold my-2 md:my-4">
              3. Sharing Your Information
            </h4>
            <p>
              • Legal Requirements: We may disclose your information if required
              by law or if we believe such action is necessary to comply with
              legal obligations or protect our rights.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <h5 className="font-semibold my-2 md:my-4">
              4. Security of Your Information
            </h5>
            <p>
              • We implement industry-standard security measures to protect your
              information from unauthorised access, disclosure, alteration, or
              destruction.{" "}
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <h6 className="font-semibold my-2 md:my-4">
              5. Cookies and Tracking Technologies
            </h6>
            <p>
              • We use cookies and similar tracking technologies to enhance your
              experience on our website. You can control the use of cookies
              through your browser settings, but disabling cookies may limit
              your ability to use certain features of our website.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <h6 className="font-semibold my-2 md:my-4">
              6. Children’s Privacy
            </h6>
            <p>
              • Our services are not intended for children under the age of 13.
              We do not knowingly collect personal information from children
              under 13. If you believe we have collected such information,
              please contact us immediately.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <h6 className="font-semibold my-2 md:my-4">
              7. Changes to This Privacy Policy
            </h6>
            <p>
              • We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new Privacy Policy on our
              website. You are advised to review this Privacy Policy
              periodically for any changes.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <h6 className="font-semibold my-2 md:my-4">8. Contact Us</h6>
            <p className="font-semibold">
              • If you have any questions or concerns about these Terms, please
              contact us at:
              <br />
              <a
                href="mailto:contact@inittechnology.co"
                className="underline hover:text-[#008080]"
              >
                contact@inittechnology.co
              </a>
              <span className="font-light"> or </span>
              <a
                href="tel:+919664570369"
                className="underline hover:text-[#008080]"
              >
                +91-96645 70369
              </a>
            </p>
          </div>
        </div>
      </div>
    </m.div>
  );
};

export default PrivacyPolicy;
